/**
 * Component: Image Slider
 */

var OplevMere = OplevMere || {};

OplevMere.video = OplevMere.video || function () {
	this.init = function () {
		videoPopup();
	};

	this.videoPopup = function () {
		$('.video-preview-image').each(function (){
			var src = $(this).data('video'); 
			$(this).magnificPopup({
				items: [
				{
					src: src,
					type: 'iframe' // this overrides default type
				}
				]
			});
		});
	}
    
	return {
		init: init
	}
}();